<div class="flag-container" *ngIf="!showForm">
    <div class="logo-container">
        <img class="uiUncollapsedLogoLanguage" src="../../assets/logo-light.png"
            alt="logo">
    </div>

    <h1 style="color: black;">{{ 'selectLanguage' | translate }} :</h1>

    <div class="flags-container">
        <div class="language-option" (click)="selectFlag('it')">
            Italiano
        </div>

        <div class="language-option" (click)="selectFlag('en')">
            English
        </div>
    </div>
</div>

<div *ngIf="showForm">
    <nz-progress class="progress-bar"
        [nzPercent]="progress"
        [nzStrokeWidth]="10"
        [nzShowInfo]="false"
        [nzStatus]="'active'"></nz-progress>

    <div *ngIf="currentStep === 0">
        <form [formGroup]="stepForm('step1')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="name">
                {{ 'nameRegister' | translate }} <span class="required">*</span>
            </label>
            <input nz-input id="name" formControlName="name" type="text"
                (input)="sanitizeInput('step1.name')">
            <div
                *ngIf="stepForm('step1').get('name')?.invalid && stepForm('step1').get('name')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <label for="surname">
                {{ 'surnameRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="surname" formControlName="surname" type="text"
                (input)="sanitizeInput('step1.surname')">
            <div
                *ngIf="stepForm('step1').get('surname')?.invalid && stepForm('step1').get('surname')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>
            <label for="birthday">
                {{ 'birthdayRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="birthday" formControlName="birthday" type="date"
                (input)="sanitizeInput('step1.birthday')">
            <div
                *ngIf="stepForm('step1').get('birthday')?.invalid && stepForm('step1').get('birthday')?.touched"
                class="error">
                <span
                    *ngIf="stepForm('step1').get('birthday')?.errors?.['required']">{{
                    'fieldRequired' | translate }}</span>
                <span
                    *ngIf="!stepForm('step1').get('birthday')?.errors?.['required'] && stepForm('step1').get('birthday')?.errors?.['ageInvalid']">{{
                    'validAge' | translate }}</span>
                <span
                    *ngIf="!stepForm('step1').get('birthday')?.errors?.['required'] && !stepForm('step1').get('birthday')?.errors?.['ageInvalid'] && stepForm('step1').get('birthday')?.errors?.['invalidDate']">{{
                    'invalidDate' | translate }}</span>
            </div>

            <div class="step-navigation">
                <button nz-button nzType="primary" type="submit"
                    style="margin: auto; width: 90%;"
                    [disabled]="stepForm('step1').invalid">{{ 'nextRegister' |
                    translate }} <i nz-icon nzType="arrow-right"></i></button>
            </div>

        </form>
    </div>

    <div *ngIf="currentStep === 1">
        <form [formGroup]="stepForm('step2')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="email">
                {{ 'emailRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="email" formControlName="email" type="email"
                (input)="sanitizeInput('step2.email')">
            <div
                *ngIf="stepForm('step2').get('email')?.invalid && stepForm('step2').get('email')?.touched"
                class="error">
                <span
                    *ngIf="stepForm('step2').get('email')?.errors?.['required']">{{
                    'fieldRequired' | translate }}</span>
                <span
                    *ngIf="!stepForm('step2').get('email')?.errors?.['required'] && stepForm('step2').get('email')?.errors?.['email']">{{
                    'invalidEmail' | translate }}</span>
            </div>

            <label for="emailConfirm">
                {{ 'emailConfirmRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="emailConfirm" formControlName="emailConfirm"
                type="email" (input)="sanitizeInput('step2.emailConfirm')">
            <div
                *ngIf="stepForm('step2').get('emailConfirm')?.touched || (stepForm('step2').touched && stepForm('step2').errors?.['emailsDoNotMatch'])"
                class="error">
                <span
                    *ngIf="stepForm('step2').get('emailConfirm')?.errors?.['required']">{{
                    'fieldRequired' | translate }}</span>
                <span
                    *ngIf="!stepForm('step2').get('emailConfirm')?.errors && !stepForm('step2').get('email')?.errors && stepForm('step2').errors?.['emailsDoNotMatch']">
                    {{ 'emailsDoNotMatch' | translate }}
                </span>
            </div>

            <div class="step-navigation">
                <button nz-button type="button" (click)="prevStep()"
                    style="width: 12%;"> <i nz-icon nzType="arrow-left"></i>
                </button>
                <button nz-button nzType="primary" type="submit"
                    style="width: 80%;"
                    [disabled]="stepForm('step2').invalid">
                    {{ 'nextRegister' | translate }} <i nz-icon
                        nzType="arrow-right"></i>
                </button>

            </div>
        </form>
    </div>

    <div *ngIf="currentStep === 2">
        <form [formGroup]="stepForm('step3')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">

            <label for="company">
                {{ 'companyRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="company" formControlName="company" type="text"
                (input)="sanitizeInput('step3.company')">
            <div
                *ngIf="stepForm('step3').get('company')?.invalid && stepForm('step3').get('company')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <label for="companyID">
                {{ 'companyIdRegister' | translate }} <span
                    class="required">*</span>
            </label>
            <input nz-input id="companyID" formControlName="companyID"
                type="text"
                (input)="sanitizeInput('step3.companyID')">
            <div
                *ngIf="stepForm('step3').get('companyID')?.invalid && stepForm('step3').get('companyID')?.touched"
                class="error">
                {{ 'fieldRequired' | translate }}
            </div>

            <div class="step-navigation">
                <button nz-button type="button" (click)="prevStep()"
                    style="width: 12%;"> <i nz-icon nzType="arrow-left"></i>
                </button>

                <button nz-button nzType="primary" type="submit"
                    style="width: 80%;"
                    [disabled]="stepForm('step3').invalid">
                    {{ 'nextRegister' | translate }} <i nz-icon
                        nzType="arrow-right"></i>
                </button>

            </div>
        </form>
    </div>

    <div *ngIf="currentStep === 3">
        <form [formGroup]="stepForm('step4')" (ngSubmit)="nextStep()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">
                <div *ngIf="!loading">
                    <h3 style="color: white;" class="text-l font-medium mb-4 text-gray-700">{{
                        'generalPrivacyTitle' | translate }}</h3> <a
                        *ngIf="resultsPrivacy?.[0]?.allegato?.ITA"
                        (click)="downloadFile(resultsPrivacy[0].allegato.ITA)"
                        class="text-blue-600 hover:underline cursor-pointer">
                        <i nz-icon nzType="link"></i> ({{ 'openPrivacy' | translate
                        }})
                    </a>
                </div>
                <div *ngIf="loading" class="text-center my-4"> <nz-spin
                        nzSimple></nz-spin> </div>
    
                <div formArrayName="privacyCheckboxes"
                    *ngIf="getPrivacyCheckboxesControls('step5').length > 0 && !loading">
                    <div
                        *ngFor="let optionCtrl of getPrivacyCheckboxesControls('step4'); let i = index"
                        [formGroupName]="i" class="mb-4 py-3">
                        <hr class="mb-3">
                        <div>
                            <div class="block text-sm text-gray-800 mb-2" *ngIf="optionCtrl.get('non_accetto_label')?.value">
                                {{ optionCtrl.get('testo')?.value }}
                                <span *ngIf="optionCtrl.get('richiesto')?.value"
                                    class="text-red-500 ml-1 required">*</span>
                            </div>
                            <nz-radio-group formControlName="selection"
                                class="radio-group-inline space-x-4">
                                <label nz-radio
                                    [nzValue]="optionCtrl.get('accetto_label')?.value" >
                                    {{ optionCtrl.get('non_accetto_label')?.value ? optionCtrl.get('accetto_label')?.value: optionCtrl.get('testo')?.value }}
                                </label> 
                                <label nz-radio  *ngIf="optionCtrl.get('non_accetto_label')?.value"
                                    [nzValue]="optionCtrl.get('non_accetto_label')?.value">
                                    {{ optionCtrl.get('non_accetto_label')?.value }}
                                </label>
                            </nz-radio-group>
                            <div
                                *ngIf="optionCtrl.get('selection')?.invalid && optionCtrl.get('selection')?.touched"
                                class="text-red-500 text-xs mt-1 error">
                                <span
                                    *ngIf="optionCtrl.get('selection')?.errors?.['required'] && optionCtrl.get('richiesto')?.value">
                                    {{ 'fieldRequired' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                *ngIf="getPrivacyCheckboxesControls('step4').length === 0 && !loading"
                class="text-gray-500 my-4">
                {{ 'noPrivacyOptions' | translate }}
            </div>

            <div class="step-navigation mt-6 flex justify-between items-center">
                <button nz-button type="button" (click)="prevStep()"
                    style="width: 12%;"> <i nz-icon nzType="arrow-left"></i>
                </button>
                <button nz-button nzType="primary"
                    style="width: 80%;"
                    type="submit"
                    >
                    {{ 'nextRegister' | translate }} <i nz-icon
                        nzType="arrow-right"></i>
                </button>
            </div>
        </form>
    </div>

    <div *ngIf="currentStep === 4">
        <form [formGroup]="stepForm('step5')" (ngSubmit)="onSubmit()">
            <img class="uiUncollapsedLogo" src="../../assets/logo-light.png"
                alt="logo">


            <div *ngIf="!loading">
                <h3 style="color: white;" class="text-l font-medium mb-4 text-gray-700">{{
                    'videoPrivacyTitle' | translate }}</h3> <a
                    *ngIf="videoPrivacy?.[0]?.allegato?.ITA"
                    (click)="downloadFile(videoPrivacy[0].allegato.ITA)"
                    class="text-blue-600 hover:underline cursor-pointer">
                    <i nz-icon nzType="link"></i> ({{ 'openPrivacy' | translate
                    }})
                </a>
            </div>
            <div *ngIf="loading" class="text-center my-4"> <nz-spin
                    nzSimple></nz-spin> </div>

            <div formArrayName="privacyCheckboxesVideo"
                *ngIf="getPrivacyCheckboxesControls('step5').length > 0 && !loading">
                <div
                    *ngFor="let optionCtrl of getPrivacyCheckboxesControls('step5'); let i = index"
                    [formGroupName]="i" class="mb-4 py-3">
                    <hr class="mb-3">
                    <div>
                        <div class="block text-sm text-gray-800 mb-2" *ngIf="optionCtrl.get('non_accetto_label')?.value">
                            {{ optionCtrl.get('testo')?.value }}
                            <span *ngIf="optionCtrl.get('richiesto')?.value"
                                class="text-red-500 ml-1 required">*</span>
                        </div>
                        <nz-radio-group formControlName="selection"
                            class="radio-group-inline space-x-4">
                            <label nz-radio
                                [nzValue]="optionCtrl.get('accetto_label')?.value">
                                {{ optionCtrl.get('non_accetto_label')?.value ? optionCtrl.get('accetto_label')?.value : optionCtrl.get('testo')?.value }}
                            </label>
                            <label nz-radio *ngIf="optionCtrl.get('non_accetto_label')?.value"
                                [nzValue]="optionCtrl.get('non_accetto_label')?.value">
                                {{ optionCtrl.get('non_accetto_label')?.value }}
                            </label>
                        </nz-radio-group>
                        <div
                            *ngIf="optionCtrl.get('selection')?.invalid && optionCtrl.get('selection')?.touched"
                            class="text-red-500 text-xs mt-1 error">
                            <span
                                *ngIf="optionCtrl.get('selection')?.errors?.['required'] && optionCtrl.get('richiesto')?.value">
                                {{ 'fieldRequired' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div
                *ngIf="getPrivacyCheckboxesControls('step5').length === 0 && !loading"
                class="text-gray-500 my-4">
                {{ 'noPrivacyOptions' | translate }}
            </div>

            <div class="step-navigation mt-6 flex justify-between items-center">
                <button nz-button type="button" (click)="prevStep()"
                    style="width: 12%;"> <i nz-icon nzType="arrow-left"></i>
                </button>
                <button
                    nz-button
                    nzType="primary"
                    type="submit"
                    style="width: 80%;"
                    [nzLoading]="loading">
                    {{ 'sendPrivacyComplilation' | translate }}
                </button>
            </div>
        </form>
    </div>

    <div *ngIf="currentStep === 5">
        <nz-result 
        [nzStatus]="isPresentPrivacy ? 'info' : 'success'"
        [nzTitle]="isPresentPrivacy ? ('compilationPrivacyExist' | translate) : ('compilationPrivacySent' | translate)"
        [nzSubTitle]="isPresentPrivacy ?('compilationPrivacyExistMessage' | translate: { name: nameUserPrivacy, expiryDate: expireDate }) : ('compilationPrivacyMessage' | translate)">
      </nz-result>
      
      </div>
      
    <div *ngIf="currentStep > 5">
        <p class="text-center text-red-500">Invalid step.</p>
    </div>

</div>

<div
    class="waiter-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
    *ngIf="loading">
    <div class="waiter text-center">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    </div>
</div>
